<template>

  <el-card :shadow="noShadow ? 'hover' : 'always'" :body-style="'background-color: ' + siteBgColor(localData.status)">

    <el-row :gutter="8.52">
       <el-col :align="(mapR || mapL) ? (noM ? 'center' : 'left') : 'center'" :span="(mapR || mapL) ? (noM  ? 24 : 12) : 24" :class="mapL ? 'pull-right' : 'pull-left'">
          <h3 v-if="!hideSite" :class="titleClass(localData.status)"><b>{{localData.siteName}}</b></h3>
          <h5 v-if="!hideSite && localData.telcoSiteId" class="text-muted"><b>{{localData.telcoSiteId}}</b></h5>
          <h5 v-if="!hideSite && localData.siteId"><span :class="titleClass(localData.status)">{{localData.status}}:</span> Site ID:&nbsp;<b>{{localData.siteId}}</b></h5>
          <h5 v-if="!hideSite && localData.siteGroup">Site Group:&nbsp;<b>{{localData.siteGroup}}</b></h5>


       <div v-if="!noStructure  && localData.structure && (localData.structure.name || localData.structure.height)"  :align="mapR ? 'left' : 'center'" :span="24">
           Structure: <strong v-if="localData.structure.name">{{localData.structure.name}}</strong>
           <span v-if="localData.structure.height">&nbsp;|&nbsp;<strong>{{localData.structure.height}}</strong>m.</span>
       </div>
       <div v-if="localData.structureName || localData.structureHeight" :align="mapR ? 'left' : 'center'" :span="24">
           Structure: <strong v-if="localData.structureName">{{localData.structureName}}</strong>
           <span v-if="localData.structureHeight">&nbsp;|&nbsp;<strong>{{localData.structureHeight}}</strong>m.</span>
        </div>

     </el-col>

      <el-col v-if="localData.latitude && localData.longitude && !noM" :span="(mapR || mapL) ? 12 : 24">

        <google-map
            v-if="!useLeaflet"
            :lat="localData.latitude"
            :lng="localData.longitude"

            :map-type="mapType"
            :map-style="mapStyle"

            :zoom="zoom"

            :draggable="draggable"
            show-nominal

            :markers="markers"

            :options="['option', 'access', 'power', 'building']"
            :optionIcons="['fa fa-bullseye', 'fa fa-road', 'fa fa-plug', 'fa fa-home']"
             />

             <leaflet-map
                v-else
                :height="height"
                :width="width"
                :lat="localData.latitude"
                :lng="localData.longitude"
                :caption="localData.siteName"
                :zoom="zoom"
                :allow-zoom="allowZoom"
                :draggable="draggable" />


      </el-col>
    </el-row>

    <el-row>
    </el-row>

  </el-card>

</template>

<script>

import {MAP_PINS} from '@/components/Data'
import SiteMixins from '@/mixins/SiteMixins'

import GoogleMap from '@/components/atoms/GoogleMap'
import LeafletMap from '@/components/maps/LeafletMap'

export default {
  mixins: [SiteMixins],

  components: {
    GoogleMap,
    LeafletMap
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },

    sharerId: {
      type: [Number, String],
      default: null
    },

    zoom: {
      type: Number,
      default: 17
    },

    height: {
      type: String,
      default: '100%'
    },

    width: {
      type: String,
      default: '100%'
    },

    mapType: {
      type: String,
      default: 'hybrid'
    },

    mapStyle: {
      type: Array,
      default: null
    },

    markers: {
      type: Array,
      default: null
    },

    addMarkers: {
      type: Boolean,
      default: false
    },

    hideSite: {
      type: Boolean,
      default: false
    },

    noStructure: {
      type: Boolean,
      default: false
    },

    allowZoom: {
      type: Boolean,
      default: false
    },

    draggable: {
      type: Boolean,
      default: false
    },

    noShadow: {
      type: Boolean,
      default: true
    },

    useLeaflet: {
      type: Boolean,
      default: false
    },

    noMap: {
      type: Boolean,
      default: false
    },

    mapLeft: {
      type: Boolean,
      default: false
    },

    mapRight: {
      type: Boolean,
      default: false
    }

  },


/*
  computed: {
    telcoSiteId: function () {

      if (this.localData && this.localData.sharers && this.sharerId) {

        for (var telco in this.localData.sharers) {

          if (this.localData.sharers[telco].organisation_id === this.sharerId) {
            return this.localData.sharers[telco].telcoSiteId
          }
        }

      } else {
        return null
      }
    }
  },
*/

  methods: {
    setSiteData (data) {
      if (data) {
        this.localData = data
      }
    }
  },


  watch: {
    siteData: function (site) {
      this.localData = site
    },

    noMap: function (nom) {
      this.noM = nom
    }
  },

  data () {
    return {
      localData: this.siteData,
      mapPins: MAP_PINS,
      mapR: this.mapRight,
      mapL: this.mapLeft,
      noM: this.noMap
    }
  },

  created () {

    if (this.mapRight && this.mapLeft) {
      this.mapR = false
    }

  }
}
</script>



// WEBPACK FOOTER //
// SiteCard.vue?3b8935d2